import React from 'react';
import PropTypes from 'prop-types';
import { ReviewAPI } from '../../api';
import { ReviewStore } from '../../store';
import { connect } from 'react-redux';
import ReviewCardList from './ReviewCardList.js';
import ReviewSnippets from './ReviewSnippets.js';

const Reviews = ({itemType='provider', data, reviews, isLoading, dispatch}) => {

  const fetchData = async () => {
    dispatch(ReviewStore.isLoading('reviewList', true));
    try {
      if (itemType === 'provider') {
        const { payload } = await ReviewAPI.getProviderReviews(data.uuid);
        dispatch(ReviewStore.setReviewList(payload, payload.length, payload.length)); // update API...
      } else {
        const { payload } = await ReviewAPI.getListingReviews(data.uuid);
        dispatch(ReviewStore.setReviewList(payload, payload.length, payload.length)); // update API...
      }
    } catch (err) {
      console.error(err); // eslint-disable-line no-console
    }
  };

  React.useEffect(() => {
    fetchData();
  }, []); // eslint-disable-line

  const providerName = ('provider_uuid' in data) ? data.provider_name : data.name;

  return (
    <React.Fragment>
      <ReviewSnippets
        isLoading={isLoading}
        data={data}
        reviews={reviews}
      />
      <ReviewCardList
        isLoading={isLoading}
        reviews={reviews}
        providerName={providerName}
      />
    </React.Fragment>
  );

};

Reviews.propTypes = {
  itemType: PropTypes.string,
  data: PropTypes.object.isRequired,
  reviews: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  return {
    reviews: state.review.reviewList,
    isLoading: state.review.reviewListLoading,
  };
};

export default connect(mapStateToProps)(Reviews);
